export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const TOGGLE_CALENDAR = 'TOGGLE_CALENDAR';

export const setSelectedDate = (date) => ({
  type: SET_SELECTED_DATE,
  date
});

export const toggleCalendar = () => ({
  type: TOGGLE_CALENDAR
});



// WEBPACK FOOTER //
// ./src/actions/dateSelector.js